@if (show) {
  <ngb-toast [autohide]="true" (hidden)="show = false">
    <ng-template ngbToastHeader>
      <div class="me-auto">
        @if (alertType == toastType.Success) {
          <i class="bi bi-check-circle-fill text-success" ></i>
        }
        @if (alertType == toastType.Error) {
          <i class="bi bi-x-circle-fill text-danger ms-2"></i>
        }
        <strong class="ms-1">{{title}}</strong>
      </div>
    </ng-template>
    {{message}}
  </ngb-toast>
}
